export default {
  activateLandingPageTitle: 'กิจกรรม',
  activateProductCardTitle: 'กิจกรรม',
  activateProductPageTitle: 'จองกิจกรรม',
  allProductsLandingPageTitle: 'จองประสบการณ์พิเศษ',
  apply: 'ใช้',
  buyTickets: 'ซื้อตั๋ว',
  cancel: 'ยกเลิก',
  clear: 'ล้าง',
  clearFilters: 'ล้างตัวกรอง',
  discoverExperiences: 'ค้นพบประสบการณ์',
  exclusive: 'สิทธิพิเศษ',
  experience: 'ประสบการณ์',
  experiencePhotoOfListing:
    'รูปภาพประสบการณ์ {{photoNumber}} ของรายการ {{listingTitle}}',
  experiences: 'ประสบการณ์',
  filterExperiences: 'กรองประสบการณ์',
  fromListingCard: 'เริ่มต้น',
  hostedBy: 'จัดโดย',
  hostLandingPageTitle: 'ประสบการณ์ท้องถิ่น',
  hostProductCardTitle: 'ประสบการณ์ท้องถิ่น',
  hostProductPageTitle: 'จองประสบการณ์ท้องถิ่น',
  landingPageTitle: 'จองประสบการณ์พิเศษ',
  mainLandingPageTitle: 'ประสบการณ์ทั้งหมด',
  more: 'เพิ่มเติม',
  noExperiencesFound: 'ไม่พบประสบการณ์',
  noExperiencesFoundFor: 'ไม่พบประสบการณ์สำหรับ',
  experiencesFoundCount: 'พบ {{count}} ประสบการณ์',
  profileImageOfHost: 'รูปโปรไฟล์ของผู้จัดกิจกรรม {{hostName}}',
  reserve: 'จอง',
  reserveLandingPageTitle: 'กิจกรรมและสิ่งอำนวยความสะดวก',
  reserveProductCardTitle: 'กิจกรรม',
  reserveProductPageTitle: 'จองกิจกรรมและสิ่งอำนวยความสะดวก',
  resultsPageTitle: 'จองประสบการณ์และกิจกรรม',
};
